import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Editor from "./pages/Editor";
import Preview from "./pages/Preview";
import PlayBack from "@pages/Playback";
import AppSettings from "@pages/AppSettings";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<Home />}
        />
        <Route
          path="/editor/:appID"
          element={<Editor />}
        />
        <Route
          path="/preview/:appID"
          element={<Preview />}
        />
        <Route
          path="/playback/:appID/:clientID/:eventID"
          element={<PlayBack />}
        />
        <Route
          path="/app/settings/:appID"
          element={<AppSettings />}
        />
      </Routes>
    </Router>
  );
}

export default App;
